import { SegmentedControlState, SegmentedControlSize } from '@hse-design/core';
import { __extends, __assign, __decorate, __metadata } from 'tslib';
import { Prop, Model, Watch, Component, Vue } from 'vue-property-decorator';
import { EnumProp } from '../../utils/enumProp.js';
import __vue_component__ from './HseSegmentedControlItem.vue.js';

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=3736%3A0
 * @storybook /?path=/story/inputs-segmentedcontrol--playground
 * @react /src-components-segmented-control
 * @reactStorybook /?path=/story/inputs-segmentedcontrol--playground
 * @requires ./HseSegmentedControlItem.vue
 */
var HseSegmentedControl = /** @class */ (function (_super) {
    __extends(HseSegmentedControl, _super);
    function HseSegmentedControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = __assign({}, SegmentedControlState.initialState);
        _this.stateRef = new SegmentedControlState(_this.setState);
        return _this;
    }
    HseSegmentedControl.prototype.setState = function (newState) {
        this.state = newState(this.state);
    };
    HseSegmentedControl.prototype.onChange = function (newValue) {
        /**
         * Вызывается при необходимости изменении активного сегмента
         * @type {string}
         */
        this.$emit('change', newValue);
    };
    HseSegmentedControl.prototype.mounted = function () {
        this.updateStateRef();
    };
    HseSegmentedControl.prototype.updated = function () {
        this.updateStateRef();
    };
    HseSegmentedControl.prototype.beforeDestroy = function () {
        this.stateRef.onWillUnmount();
    };
    Object.defineProperty(HseSegmentedControl.prototype, "stateRefArgs", {
        get: function () {
            return [
                this.state,
                {
                    items: this.items,
                    currentItemValue: this.value
                },
                {
                    onChange: this.onChange
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    HseSegmentedControl.prototype.updateStateRef = function () {
        var _a;
        (_a = this.stateRef).update.apply(_a, this.stateRefArgs);
    };
    HseSegmentedControl.prototype.updateStateRefOnChanges = function () {
        this.updateStateRef();
    };
    HseSegmentedControl.prototype.onKeyDown = function (e) {
        this.stateRef.onKeyDown(e);
    };
    HseSegmentedControl.prototype.onBlur = function () {
        this.stateRef.onBlur();
    };
    HseSegmentedControl.prototype.onItemClick = function (newValue) {
        this.stateRef.onClick(newValue);
    };
    __decorate([
        Prop(EnumProp(SegmentedControlSize.medium, SegmentedControlSize)),
        __metadata("design:type", String)
    ], HseSegmentedControl.prototype, "size", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], HseSegmentedControl.prototype, "items", void 0);
    __decorate([
        Model('change'),
        __metadata("design:type", Object)
    ], HseSegmentedControl.prototype, "value", void 0);
    __decorate([
        Watch('segmentedControlArgs'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HseSegmentedControl.prototype, "updateStateRefOnChanges", null);
    HseSegmentedControl = __decorate([
        Component({
            name: 'HseSegmentedControl',
            components: {
                HseSegmentedControlItem: __vue_component__
            }
        })
    ], HseSegmentedControl);
    return HseSegmentedControl;
}(Vue));

export default HseSegmentedControl;
